module.exports = __webpack_public_path__ + "img/hrm-ashley-lg.253141a.png";